module.exports = __webpack_public_path__ + "media/img/vca/categories/restaurant-9c70aad0e6df119cc89869678c6f1eaa.png";